import UserModel from 'src/models/UserModel';
import { useOptimizelyFlag } from 'src/services/flags/hooks/useOptimizelyFlag';

export const useShouldDisplaySaasPayments = () => {
  const { enabled: paymentsEnabled } = useOptimizelyFlag('payments_enabled');

  if (!paymentsEnabled) {
    return false;
  }

  if (!UserModel.getInstance().hadAnySub) {
    return false;
  }

  return true;
};
